import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilters = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0.51055 1.67516C2.20306 3.8335 5.32835 7.8335 5.32835 7.8335V12.8335C5.32835 13.2918 5.7054 13.6668 6.16623 13.6668H7.84199C8.30282 13.6668 8.67986 13.2918 8.67986 12.8335V7.8335C8.67986 7.8335 11.7968 3.8335 13.4893 1.67516C13.9166 1.12516 13.5228 0.333496 12.8274 0.333496H1.17247C0.477035 0.333496 0.0832323 1.12516 0.51055 1.67516Z",
		fill: "#1F4C5C"
	})]
});
const ForwardRef = forwardRef(SvgFilters);
export { ForwardRef as ReactComponent };
